import React from 'react';
import ReactDOM from 'react-dom';

import MooTeam from './MooTeam';
import registerServiceWorker from 'registerServiceWorker';

registerServiceWorker();

ReactDOM.render(<MooTeam />, document.getElementById('root'));
